import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Whether a due date has passed, at day granularity.
 *
 * Due dates are stored at midnight UTC as a stand-in for a calendar day, so we read that day in UTC
 * and compare it to the member's *local* day. A task flips overdue at the member's local midnight which
 * parsing the UTC instant in local time would cause for members west of UTC. Serves both tasks
 * (`due_date`) and groups (`next_due_date`); returns false when there's no date.
 */
export default function isOverdue(date: string | null | undefined): boolean {
    if (!date) {
        return false;
    }
    return dayjs.utc(date).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD');
}
